export default {
    field: {
        type: "file",
        name: "survey",
        fileType: ".csv",
    },
    loading: "loading",
    upload: "upload"
}